import { render, staticRenderFns } from "./DemandList.vue?vue&type=template&id=afc67552"
import script from "./DemandList.vue?vue&type=script&lang=js"
export * from "./DemandList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports